import LastOperationsPage from './LastOperationsPage';

export default LastOperationsPage;
